/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { DrawerProps } from './types';
import './styles.scss';
import TDrawer, { DrawerAnalytics } from './Drawer';
import BackButton from './BackButton';
import Body from './Body';
import Footer from './Footer';

/**
 * UI Toolkit : Drawer
 * @public
 */
const Drawer: React.FC<DrawerProps> & {
  BackButton: typeof BackButton;
  Body: typeof Body;
  Footer: typeof Footer;
} = ({ id, children, isOpen, onClose, trackId, ...rest }) => {
  if (trackId) {
    return (
      <DrawerAnalytics
        {...rest}
        id={id}
        trackId={trackId}
        onClose={onClose}
        isOpen={isOpen}
      >
        {children}
      </DrawerAnalytics>
    );
  }
  return (
    <TDrawer
      id={id}
      onClose={onClose}
      isOpen={isOpen}
    >
      {children}
    </TDrawer>
  );
};

Drawer.BackButton = BackButton;
Drawer.Body = Body;
Drawer.Footer = Footer;

export type { DrawerProps };
export default Drawer;
